import { registerPlugin } from '@capacitor/core';
const VideoDataBridge = registerPlugin('VideoDataBridge', {
    web: () => import('./web').then((m) => new m.VideoDataBridgeWeb()),
});
export * from './definitions';
export { VideoDataBridge };
//# sourceMappingURL=index.js.map